/* eslint-disable */
/* added new script based on the requirement*/

const scriptSrc = `${window.__config__.SURFLY_URL}/surfly.js`;
const widget_key = window.__config__.SURFLY_WIDGET_KEY;

(function (s, u, r, f, l, y) {
  s[f] = s[f] || {
    init: function () {
      s[f].q = arguments;
    },
  };
  l = u.createElement(r);
  y = u.getElementsByTagName(r)[0];
  l.async = 1;
  l.src = scriptSrc;
  y.parentNode.insertBefore(l, y);
})(window, document, 'script', 'Surfly');

var settings = {
  // Surfly session options can be set here, or at the Company/Plan levels.
  widget_key: widget_key,
};

Surfly.init(settings, function (initResult) {
  if (initResult.success) {
    // API calls can now be made!
    if (!Surfly.isInsideSession) {
      Surfly.button();
    }
  } else {
    console.log('Surfly was unable to initialize properly.');
  }
});
